import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { AIStepLayout } from '../masterclass/ai/AIStepLayout';
import { useProgramCreation } from '../ProgramCreationContext';
import { API } from '../../../../api';
import DosenInput from '../../../../pages/new-designs/components/DosenInput';
import { useAppSelector } from '../../../../redux/hooks';

const MENTORSHIP_STEPS = ['Program Name', 'Learning Objectives', 'Members'];

export function MentorshipProgramName() {
  const navigate = useNavigate();
  const { state, dispatch } = useProgramCreation();
  const { coId: coIdParam = '', orgId: orgIdParam = '', id: routeGroupId = '' } = useParams();
  const orgIdFromStore = useAppSelector((s) => s.orgDetails.data?._id) || orgIdParam;
  const parentGroupId = useAppSelector((s) => s.orgDetails.data?.grpId) || routeGroupId;
  const [name, setName] = useState(state.mentorship.name || '');
  const [saving, setSaving] = useState(false);

  const createOrUpdateGroup = async () => {
    let groupId = state.groupId;
    const formData = new FormData();

    if (!orgIdFromStore || !parentGroupId) {
      throw new Error('Missing workspace context to create the group');
    }

    if (!groupId) {
      const response = await API.createGroup({
        orgId: orgIdFromStore,
        name: name.trim(),
        parent: parentGroupId
      });
      groupId = response.data.groupDetails.grpId;
    }

    formData.append('model', 'mentorship');
    formData.append('includeTask', 'true');
    formData.append('allowEditing', 'true');
    formData.append('mentee', 'mentee');
    formData.append('mentor', 'mentor');
    formData.append('name', name.trim());

    if (!groupId) {
      throw new Error('Failed to create mentorship group');
    }

    await API.updateGroupInfo({
      orgId: coIdParam || orgIdParam || orgIdFromStore,
      grpId: groupId,
      formData
    });

    const finalGroupId = groupId || '';
    dispatch({ type: 'SET_GROUP_ID', payload: finalGroupId });
    dispatch({ type: 'SET_BUILD_MODE', payload: 'manual' });
    dispatch({ type: 'UPDATE_MENTORSHIP', payload: { name: name.trim() } });
  };

  const handleNext = async () => {
    if (!name.trim()) return;

    setSaving(true);
    try {
      await createOrUpdateGroup();
      navigate('../learning-objectives');
    } catch (err) {
      console.error(err);
      toast.error('Não foi possível salvar o programa. Tente novamente.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <AIStepLayout
      stepTitle="Program Name"
      steps={MENTORSHIP_STEPS}
      title="Program Name"
      onBack={() => navigate(-1)}
      onNext={handleNext}
      nextDisabled={!name.trim() || saving}
    >
      <DosenInput
        label="Program Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        placeholder="Name your mentorship program"
        maxChars={75}
        fullWidth
      />
    </AIStepLayout>
  );
}

export default MentorshipProgramName;
